export const getDesktopColumnWidth = (listLength) => {
    switch (listLength) {
        case 2:
            return 'lg:w-1/2';
        case 3:
            return 'lg:w-1/3';
        case 4:
            return 'lg:w-1/4';
        default:
            return 'lg:w-full';
    }
};
